/* eslint import/no-extraneous-dependencies: off*/
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ConfigDB from "../../data/customizer/config";

const initialState = {
    customizer: ConfigDB.data,
    configData: {},
    layout: 'ltr',
    sidebar_types: {},
    settings: '',
    color: {},
    mix_background_layout: '',
    animation:'',
    sideMenuToggle:false,
};

const themeSlice = createSlice({
    name: 'setting/theme',
    initialState,
    reducers: {
        setThemeColor: (state, action) => {
            state.customizer.color.primary_color = action.payload.primary_color;
            state.customizer.color.secondary_color = action.payload.secondary_color;
        },
        setSideMenuToggle: (state, action) => {
            state.sideMenuToggle = action.payload ;
        },
    },
    extraReducers: {}
});

export const { setThemeColor,setSideMenuToggle } = themeSlice.actions;

export default themeSlice.reducer;